import actions from "~/shared/actions";

export const defaultState = [];

export default function prognosisReducer(state = defaultState, action) {
	switch (action.type) {
		case actions.POLICY_PROGNOSIS_RESPONSE: {
			const { polisenummer, prognosis } = action.data;
			return Array.from(state)
				.filter((p) => p.polisenummer !== polisenummer)
				.concat({ ...prognosis, polisenummer });
		}
		case actions.POLICY_PROGNOSIS_FAILURE: {
			const { polisenummer } = action.data;

			return Array.from(state)
				.filter((p) => p.polisenummer !== polisenummer)
				.concat({
					polisenummer,
					fetchPrognosisFailed: true,
				});
		}
		case actions.RESET_PROGNOSIS:
			return [];
		default:
			return state;
	}
}
